import services from '../../../services'

// const moduleName = 'user'
// const lastUpdateTimeKey = `__module_${moduleName}_last_update_time__`
// const timeGap = 5 * 60 * 1000

const state = {
  info: {}
}

const actions = {
  async userList ({ commit }, query) {
    return await services.user_query(query).then(res => {
      // res.results.forEach((element) => {
      //   element.enableName = element.enable === 0 ? '禁用' : '启用'
      // }, this)
      return res
    })
  },
  async getUserRoleid ({ commit }, id) {
    let res = await services.user_getUer(id)
    return res ? res.id : undefined
  },
  async userListByUserName ({ commit }, query) {
    return await services.user_userListByUserName(query)
  },
  async userAll ({ commit }, query) {
    return await services.user_userAll(query)
  },
  async getUser ({ commit }, id) {
    // let lastUpdateTime = state.info[lastUpdateTimeKey] || 0
    // if (Date.now() - lastUpdateTime < timeGap) {
    //   return Promise.resolve(state.info)
    // }
    return await services.user_getUer(id).then(res => {
      commit('userInfo', res)
      return res
    })
  },
  async addUser ({ commit }, options) {
    return await services.user_add(options)
  },
  async updateUser ({ commit }, options) {
    return await services.user_update(options.id, options)
  },
  async deleteUser ({ commit }, query) {
    return await services.user_delete(query)
  },
  async login ({ commit }, options) {
    return await services.user_login(options)
  },
  async tokenVerify ({ commit }, options) {
    return await services.user_tokenVerify(options)
  },
  async logout ({ commit }) {
    return await services.user_logout()
  },
  async forgetPasswd ({ commit }) {
    return await services.user_forgetPasswd()
  },
  async updateIdtoken ({ commit }, query) {
    return await services.user_updateIdtoken(query)
  },
  async getToken({ commit }, query) {
    return await services.user_token(query)
  },
  async getTokenSJ ({ commit }, options) {
    return await services.user_getTokenSJ(options)
  },
  async getUserInfoSJ({ commit }, options) {
    return await services.user_getUserInfoSJ(options)
  },
  async loginByJaccount({ commit }, options) {
    return await services.user_loginByJaccount(options)
  },
  async logoutByJaccount ({ commit }, options) {
    return await services.user_logoutByJaccount(options)
  },
  async getCsInfos ({ commit }, options) {
    return await services.user_getCsInfos(options)
  },
}

const mutations = {
  userInfo (state, payload) {
    let userInfo = payload || {}
    // userInfo[lastUpdateTimeKey] = Date.now()
    state.info = userInfo
  }
}
export default {
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/system/user.js